import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Breitscheidplatz from "@/pages/Breitscheidplatz";
import UseCasePage from "@/pages/UseCasePage";
import News from "@/pages/News";
import Home from "@/pages/Home";
import { Projekte, Technologie, Presse } from "@/pages/Archiv";
import { USECASES } from "@/lib/usecases";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, LANGS } from "@/lib/i18n";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          {LANGS.filter((l) => l !== "de").map((l) => (
            <Route key={l} path={`/${l}`} element={<Home />} />
          ))}
          <Route path="/projekte" element={<Projekte />} />
          <Route path="/en/projects" element={<Projekte />} />
          <Route path="/technologie" element={<Technologie />} />
          <Route path="/en/technology" element={<Technologie />} />
          <Route path="/presse" element={<Presse />} />
          <Route path="/en/press" element={<Presse />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/breitscheidplatz" element={<Breitscheidplatz />} />
          <Route path="/aktuelles" element={<News />} />
          <Route path="/en/news" element={<News />} />
          {USECASES.map((u) => (
            <Route key={u.deSlug} path={`/${u.deSlug}`} element={<UseCasePage uc={u} />} />
          ))}
          {USECASES.map((u) => (
            <Route key={u.enSlug} path={`/en/${u.enSlug}`} element={<UseCasePage uc={u} />} />
          ))}
          {USECASES.filter((u) => u.frSlug).map((u) => (
            <Route key={u.frSlug} path={`/fr/${u.frSlug}`} element={<UseCasePage uc={u} />} />
          ))}
          {USECASES.filter((u) => u.plSlug).map((u) => (
            <Route key={u.plSlug} path={`/pl/${u.plSlug}`} element={<UseCasePage uc={u} />} />
          ))}
        </Routes>
        <Toaster richColors position="top-center" />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
